import { createAsyncThunk } from "@reduxjs/toolkit";
import { ReferentialKey } from "api/referential";
import { referentialsApi } from "services/swagger-api/referentialsAPI";

export const getReferentialByKey = createAsyncThunk(
  'subscriptionProcess/getReferentialByKey',
  async (referentialKey: ReferentialKey) => {
    const response = await referentialsApi.getReferentialsByKey({ referentialKey })

    return { referentialKey, referential: response.referential }
  }
);
